import groupApi from '@/api/group'
import { getUUID } from '@/utils/helper'
import { action, computed, observable, reaction, toJS } from 'mobx'
import { ETeamNumberStatus, ETeamUserRole, ETeamUserStatus } from './team.enum'

export class TeamNumber {
  @observable public id = ''
  @observable public ownerId = ''
  @observable public faxNumber = ''
  @observable public status: ETeamNumberStatus = ETeamNumberStatus.ENABLE
  @observable public dateExpiry = ''
}

export class TeamUser {
  @observable public id = ''
  @observable public memberId = ''
  @observable public email = ''

  @observable public name = ''

  @computed public get initials(): string {
    return (this.name.charAt(0) || this.email.charAt(0)).toUpperCase()
  }

  @observable public note = ''
  @observable public numbers: TeamNumber[] = []
  @observable public status = ETeamUserStatus.ACTIVE
  @observable public role: ETeamUserRole = ETeamUserRole.NORMAL_MEMBER
  // @observable public page = 0

  @action public updateNote(note: string) {
    this.note = note
  }

  @action public updateStatus(status: ETeamUserStatus) {
    this.status = status
  }

  @computed public get isPending() {
    return this.status === ETeamUserStatus.PENDING
  }

  // 是否是管理员
  @computed public get isAdmin(): boolean {
    return this.role === ETeamUserRole.ADMIN
  }

  // 激活使用的号码列表
  @computed public get applyNumbers(): TeamNumber[] {
    return this.numbers.filter((n) => n.status === ETeamNumberStatus.ENABLE)
  }

  @action public resetLocalNumbersStatus2ActiveByNumber(numberList: string[]) {
    this.numbers.forEach((n) => {
      if (numberList.includes(n.faxNumber)) {
        n.status = ETeamNumberStatus.ENABLE
      } else {
        n.status = ETeamNumberStatus.DISABLE
      }
    })
  }

  // test_deserialization(data?: any) {
  //   this.id = getUUID(12)
  //   const rd = Number(Math.random() * 1995).toFixed(0)
  //   this.email = 'tom' + rd + '@gmail.com'
  //   // this.firstName = 'tom'
  //   // this.lastName = rd
  //   this.name = 'tom ' + rd
  //   this.status = ETeamUserStatus.ACTIVE
  // }

  deserialization2(data?: any) {
    //     createTime: "2020-09-27 07:25:42:000 CST"
    // groupFaxNumberVOList: [{id: "5eb40a656661194c67c753db", faxNumber: "+13343784500", ownerId: "5e51e615221ba150c32b9d25",…},…]
    // groupMemberId: null
    // groupOwnerId: "5e51e615221ba150c32b9d25"
    // id: 4
    // memberEmail: "nxw1995@qq.com"
    // memberName: null
    // role: "admin"
    // status: 0
    // updateTime: "2020-09-27 07:25:42:000 CST"

    const { id, groupFaxNumberVOList = [], memberEmail, groupMemberId, memberName, role = ETeamUserRole.NORMAL_MEMBER, status = ETeamUserStatus.ACTIVE } = data
    this.id = id
    this.memberId = groupMemberId || ''
    this.email = memberEmail
    this.name = memberName || ''
    this.status = status
    this.role = role
    this.numbers = observable(groupFaxNumberVOList as any)
  }
}

interface ITeam {
  users?: TeamUser[]

  addUser?: (user: TeamUser) => void
  deleteUser?: (user: TeamUser) => void
  freezeUser?: (user: TeamUser) => void
  unfreezeUser?: (user: TeamUser) => void
}

export class Team implements ITeam {
  private rootStore: any

  @observable public users: TeamUser[] = []

  @observable public editShowModal = false
  @observable public addShowModal = false
  @observable public manageNumbersShowModal = false
  @observable public activeEditUser?: TeamUser
  @observable public activeManageNumbersUser?: TeamUser

  constructor(rootStore: any) {
    this.rootStore = rootStore

    // const self = new TeamUser()
    // self.deserialization2({
    //   // createTime: "2020-09-27 07:25:42:000 CST"
    //   groupFaxNumberVOList: [],
    //   groupMemberId: '',
    //   groupOwnerId: '',
    //   id: '',
    //   memberEmail: '',
    //   memberName: '',
    //   role: ETeamUserRole.ADMIN,
    //   status: ETeamUserStatus.ACTIVE,
    //   // updateTime: "2020-09-27 07:25:42:000 CST"
    // })

    // // 添加自己
    // this.addUser(self)

    // const tu1 = new TeamUser()
    // tu1.test_deserialization()
    // tu1.status = ETeamUserStatus.ACTIVE

    // const tu2 = new TeamUser()
    // tu2.test_deserialization()
    // tu2.status = ETeamUserStatus.LOCK

    // const tu3 = new TeamUser()
    // tu3.test_deserialization()
    // tu3.status = ETeamUserStatus.PENDING

    // this.addUser(tu1)

    // this.addUser(tu2)

    // this.addUser(tu3)

    // test
    // let i = 5
    // while (i > 0) {
    //   const tu = new TeamUser()
    //   tu.deserialization()
    //   this.addUser(tu)
    //   i--
    // }

    // Promise.resolve().then(() => {
    //   reaction(
    //     () => rootStore.userStore.userInfo,
    //     (userInfo: any) => {
    //       console.log('reaction userInfo', toJS(userInfo))
    //     }
    //   )
    // })
  }

  @action public openEditUserModal(user: TeamUser) {
    this.activeEditUser = user
    this.editShowModal = true
  }

  @action public closeEditUserModal() {
    // this.activeEditUser;
    this.editShowModal = false
  }

  @action public openManageNumbersShowModal(user: TeamUser) {
    this.activeManageNumbersUser = user
    this.manageNumbersShowModal = true
  }

  @action public closeManageNumbersShowModal() {
    // 清除当前正在操作的 成员
    this.activeManageNumbersUser = void 0
    // 关闭弹窗
    this.manageNumbersShowModal = false
  }

  @action public openAddUserModal() {
    this.addShowModal = true
  }
  @action public closeAddUserModal() {
    this.addShowModal = false
  }

  @action public addUser(user: TeamUser) {
    this.users.push(user)
  }

  @action public localDeleteUser(userid: string) {
    this.users = this.users.filter((targetU) => targetU.id !== userid)
  }

  /**
   * 获取团队成员列表
   */
  @action public async requestUserList() {
    const list: any = (await groupApi.list()) as Promise<any>
    this.users = (list || []).map((u: any) => {
      const newUser = new TeamUser()
      newUser.deserialization2(u)
      return newUser
    })
  }

  /**
   * 给成员 分配号码
   * @param user
   * @param numberList
   */
  @action public async requestAllocateFaxNumber(
    user: TeamUser,
    // numberList: TeamNumber[]
    numbers: string[]
  ) {
    let userid = user.memberId
    // pending 状态的用户 使用 email 作为参数
    if (user.isPending) {
      userid = user.email
    }
    await groupApi.allocateFaxNumber(userid, numbers)
  }

  // 删除用户
  @action public async deleteUser(user: TeamUser) {
    // 必须是已激活 或者 冻结的用户
    if ([ETeamUserStatus.ACTIVE, ETeamUserStatus.LOCK].includes(user.status)) {
      await groupApi.delete(user.memberId)
      await this.localDeleteUser(user.id)
    }
  }

  /**
   * 冻结用户
   * @param user
   */
  @action public async freezeUser(user: TeamUser) {
    // 必须是已激活用户
    if ([ETeamUserStatus.ACTIVE].includes(user.status)) {
      await groupApi.lock(user.memberId)
    }
    user.updateStatus(ETeamUserStatus.LOCK)
  }

  /**
   * 激活用户
   * @param user
   */
  @action public async unfreezeUser(user: TeamUser) {
    // 必须是已冻结用户
    if ([ETeamUserStatus.LOCK].includes(user.status)) {
      await groupApi.unLock(user.memberId)
    }
    user.updateStatus(ETeamUserStatus.ACTIVE)
  }

  /**
   * 重发邀请
   * @param user 团队用户 （未激活状态）
   */
  @action public async ReSendInvitation(user: TeamUser) {
    // 未激活才能进行重发邀请
    if (user.status === ETeamUserStatus.PENDING) {
      await groupApi.reInvite(user.email)
    }
  }

  /**
   * 取消邀请
   * @param user 团队用户 （未激活状态）
   */
  @action public async cancelInvitation(user: TeamUser) {
    // 未激活才能进行取消邀请
    if (user.status === ETeamUserStatus.PENDING) {
      await groupApi.cancleInvite(user.email)
    }
  }

  // 更新用户信息 note
  @action public async updateUserInfo(user: TeamUser, { note }: Record<string, string>) {
    await groupApi.updateUserInfo(user.memberId, { note })
    // await new Promise((re) => setTimeout(re, 2e3))
    user.updateNote(note)
  }
}

export default Team
